import { queryOptions, useQuery } from '@tanstack/react-query'

import { intentionApi } from '../api/intentionApi'
import type { INTENTION_TYPE } from '../models/Intention.enums'

export const getIntentionQueryOptions = <Type extends INTENTION_TYPE>(
  intentionId: number | undefined,
  shareToken: string | undefined,
  type: Type,
) =>
  queryOptions({
    // oxlint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['intention', type, intentionId],
    queryFn: ({ signal }) =>
      // Function will never be called without intentionId because enabled is false when intentionId is falsy
      intentionApi.getIntention({ intentionId: intentionId || -1, shareToken, type }, { signal }),
    retry: 1,
    staleTime: 60 * 1000 * 10, // 10 minutes
    enabled: !!intentionId,
  })

export const useIntentionQuery = <Type extends INTENTION_TYPE>(
  intentionId: number | undefined,
  shareToken: string | undefined,
  type: Type,
) => {
  const query = useQuery(getIntentionQueryOptions(intentionId, shareToken, type))

  return {
    data: query.data,
    intention: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isSuccess: query.isSuccess,
    error: query.error,
  }
}
